@if (showSwitcher && activeMode) {
  <div class="app-switcher d-none d-lg-flex align-items-center m-l-8">
    <button
      type="button"
      class="app-switcher-trigger"
      [class.is-open]="menuOpen"
      (click)="menuOpen = !menuOpen; $event.stopPropagation()"
      [attr.aria-expanded]="menuOpen"
      aria-haspopup="true"
    >
      <i-tabler name="layout-dashboard" class="app-switcher-trigger-icon"></i-tabler>
      <span class="app-switcher-trigger-label">{{ activeMode.displayName }}</span>
      <i-tabler
        name="chevron-down"
        class="app-switcher-trigger-chevron"
        [class.is-open]="menuOpen"
      ></i-tabler>
    </button>
    @if (menuOpen) {
      <div class="app-switcher-dropdown" (click)="$event.stopPropagation()">
        @for (m of availableModes; track m.id) {
          <button
            type="button"
            class="app-switcher-item"
            [class.is-active]="activeMode && m.id === activeMode.id"
            [disabled]="activeMode && m.id === activeMode.id"
            (click)="selectMode(m)"
          >
            <span class="app-switcher-item-check" aria-hidden="true">
              @if (activeMode && m.id === activeMode.id) {
                <i-tabler name="check"></i-tabler>
              }
            </span>
            <span class="app-switcher-item-label">{{ m.displayName }}</span>
          </button>
        }
      </div>
    }
  </div>
}
